import React from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from '@app/src/common/Modal';
import { useSelector } from 'react-redux';
import {
  Wrapper,
  Head,
  Content,
  IconClose,
  LoaderWrapper,
  ActionWrapper,
  ButtonPublish,
  ButtonPackage
} from './styled';
import { Icon } from '@app/src/common/Icon';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { COLORS } from '@app/src/ui';

interface Props {
  handleCloseModal?: Function;
  isDisplay: boolean;
  categoryId: number;
}

export const ModalAvailableRepublish: React.FC<Props> = ({
  handleCloseModal,
  isDisplay,
  categoryId,
}) => {
  const history = useHistory();
  const isLoading = useSelector(state => state.announcement.isFetchingRepublish);
  const categoryConfig = CATEGORIES[CATEGORY[categoryId]];

  const handleClickPackage = () => {
    history.push(categoryConfig.paths.purchasePackage.stepSelection);
  };

  const handleClickPublish = () => {
    history.push(categoryConfig.paths.purchasePrint.stepOne);
  };

  return (
    <React.Fragment>
      <Modal show={isDisplay} closeModal={handleCloseModal} customBody>
        <Wrapper>
          <Head>
            Republica tu aviso
              <IconClose onClick={handleCloseModal}>
              <Icon data-name="icon-close-bold" fill="#f2f2f2" width="14" height="14" />
            </IconClose>
          </Head>
          {
            isLoading ?
              <LoaderWrapper>
                <Icon data-name='icon-circle' fill='#ccc' width={'16'} height={'16'} />
              </LoaderWrapper>
              :
              <Content>
                <p>No se cuenta con paquetes disponibles de esta categoría</p>
                <ActionWrapper>
                  <ButtonPublish
                    background={COLORS.BLACK_BOLD}
                    width={240}
                    color="#fff"
                    handleClick={handleClickPublish}>Publicar Aviso</ButtonPublish>
                  <ButtonPackage
                    background={COLORS.BLACK_BOLD}
                    handleClick={handleClickPackage}
                    color="#fff"
                    width={240}>Comprar Paquete</ButtonPackage>
                </ActionWrapper>
              </Content>
          }
        </Wrapper>
      </Modal>
    </React.Fragment>
  );
};